import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ManagementService } from '../../services/management.service';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';

@Component({
  selector: 'app-area-register-modal',
  templateUrl: './area-register-modal.component.html',
  styleUrl: './area-register-modal.component.scss',
  providers: [DialogService],
})
export class AreaRegisterModalComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() registerComplete = new EventEmitter<void>();

  isDisabled: boolean = true;
  area: string | null = null;

  hasInteracted: { [key: string]: boolean } = {
    area: false,
  };

  constructor(
    private managementService: ManagementService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.resetForm();
  }

  onChangeInput(event: any, type: string) {
    this.hasInteracted[type] = true;
    switch (type) {
      case 'area':
        this.area = event;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.validateForm();
  }

  validateForm() {
    this.isDisabled = !this.area;
  }

  onRegister() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const request = {
      nameArea: this.area,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    Object.entries(request).forEach(([key, value]) =>
      appendIfDefined(key, value)
    );

    this.managementService.createArea(formData).subscribe({
      next: (response) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalSuccessComponent, {
          header: '',
          data: {
            text: 'Tu registro ha sido realizado con éxito.',
            title: '¡Éxito!',
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.registerComplete.emit();
        this.closeDialog();
      },

      error: (err) => {
        loadingRef.close();

        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text:
              err.error?.error ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        // this.resetForm();
        this.closeDialog();
      },
    });
    // this.closeDialog();
  }

  resetForm() {
    this.area = null;
    this.hasInteracted = {
      area: false,
    };
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.resetForm();
  }
}
